/** Utilities with regards to filtering Offers by price */
import { List, Map } from 'immutable'

/** Nearest round increment to set initial min/max limit to */
export const ROUND_PRICE_LIMIT_TO = 50;

/** Given a set of offers, produces a Map{ minLimit, maxLimit }
 * based on the actual costs in the offers. If there are no offers,
 * behaviour is undefined (with both usually zero.)
 */
export const limitsFromOffers = (offers = List()) =>
    offers.reduce( (limits, offer) => {
        const cost = offer.getIn(['cost','amount'], 0)
        return limits
            .update('minLimit', min =>
                min == null || cost < min
                    ? cost
                    : min)
            .update('maxLimit', max =>
                max == null || cost > max
                    ? cost
                    : max)
    },Map())
        // Make nice round numbers
        .update('minLimit', m => Math.floor( m / ROUND_PRICE_LIMIT_TO ) * ROUND_PRICE_LIMIT_TO)
        .update('maxLimit', m => Math.ceil( m / ROUND_PRICE_LIMIT_TO ) * ROUND_PRICE_LIMIT_TO)


/** Given a price range, produces a predicate function for checking
 * that an offer falls within the price range.
 */
export const priceRangePredicate = (priceRange = Map()) => (offer = Map()) => {
    const cost = offer.getIn(['cost','amount'], 0)
    return cost >= priceRange.get('min') && cost <= priceRange.get('max')
}



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/priceRange/priceRange.js